import { NewsContentType } from '@/types/enum';
const image1 = 'https://p1-mp.oeeee.com/202210/13/538x403_6347cc9b6f397.png';
const image2 = 'https://p1-mp.oeeee.com/202210/13/800x600_6347cd0ccbef7.png';
const image3 = 'https://p1-mp.oeeee.com/202210/13/800x600_6347cd17f12c8.png';
const image4 = 'https://p1-mp.oeeee.com/202210/13/800x601_6347cd252405f.png';
export default {
  id: '20221013', //  模块 id
  title: '荒山改造迎丰收，叮咚买菜科学种植口感烟薯助农增收', // 标题
  origin: '2022-10-13 来源：南方都市报', // 新闻来源
  editor: '编辑：许文茜', // 编辑者
  content: [
    {
      type: NewsContentType.Text,
      text:
        '随着多地陆续迎来不同幅度的降温，不少街头已经飘起了炒货、烤红薯的香味。随着需求增加，十月以来，叮咚买菜红薯类商品销量对比上月已经增长了30%左右，其中更受欢迎的烟薯，销量增长已超40%。相关人员表示，随着大部分地区天气变冷，红薯等秋冬应季农产品的销量还会继续提升。',
    },
    {
      type: NewsContentType.Text,
      text:
        '往种植源头去追溯，位于山东济南莱芜区苗山镇的叮咚买菜烟薯基地近日正在繁忙地采收。这几天，基地的技术员段伦江每天早上4点多就起床，在亲手采收之外，他还要把控包括规格、成色、糖度等在内的采收结果，确保运送到叮咚买菜大仓的烟薯的品质。',
    },
    {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      text:
        '段伦江是一位退伍军人，1993年入伍服役，还在部队期间全师比武获得第二名，荣立二等功一次、三等功三次，后来转业回乡从事餐饮工作。因亲人身体原因，他偶然发现，吃烟薯这样的粗粮对身体健康有着很大的帮助，为了让家人和更多人吃到品质高、好吃的烟薯，他也从此开启了自己的种植事业。',
    }, {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      text:
        '沙地种烟薯，科学种植迎丰收',
    }, {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      text:
        '品种繁多的红薯是人们餐桌上最普通、最便宜的农产品之一，但是其背后的种植过程却有着并不低的门槛。',
    }, {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      text:
        '段伦江介绍道，其实目前很多红薯的种植方式依然比较传统，像宽行密植、高垄横插、水肥辅助等技术较少能得到成熟的推广使用，甘薯脱毒种薯种苗的使用率也较低，应对病虫害和药残等能力尚有不足，加上一些盲目追求产量的做法，也导致甜度稳定、品质高的红薯产量较低。',
    }, {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      text:
        '叮咚买菜烟薯基地用的品种是有名的“烟薯25”，但采用的是团队自有培育出来的脱毒种苗，而非外部购买，确保品质的统一与稳定，也最大限度防止带入各种病害；其次在耕种前，会深翻土地、起高垄，还会倾洒草木灰用以巩固防病害能力、促进种苗健康生长，同时保护土地营养。',
    }, 
    {
      type: 1,
      title: '',
      src: [image1],
    },
    {
      type: NewsContentType.Text,
      text:
        '另外，在种植过程中，基地还使用了成本更高的银灰色地膜，能够帮助补光，提高植株的光合作用，最终提高糖度。再用水肥一体化的滴灌设备，控制土壤湿度和补充缺失微量元素。',
    }, 
    {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      text:
        '在此基础上，基地还推翻了那些追求高产、化肥催产的做法，不盲目使用化肥，而是多采用有机肥，还有以羊粪为主的农家肥，精准施肥、科学用水，提升土地的有机质和营养，保证烟薯的品质和口感，在这一前提下再追求合理的亩产',
    }, 
    {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      text:
        '这样一来，虽然付出的成本和精力相对更高，但是收获却也更大。',
    },     {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      text:
        '抱着刚挖出来的红薯，基地片区的负责人之一、土生土长的苗山人蒋方忠就感慨道：“一开始看栽苗和起垄的方式和之前自己家种完全不一样，还担心能不能活，还有到后面地里也没用过化肥，担心肥力不够，产量不高。结果现在看结薯率很高，一亩地能结5000斤以上的红薯，而且我们的基地垄起得高，结薯后瓜形更胖更直顺，口感也比我们以前种的更加香甜。”',
    },
    {
      type: 1,
      title: '',
      src: [image2],
    },
    {
      type: NewsContentType.Text,
      text:
        '荒山变基地，线上渠道带动农民增收',
    }, 
    {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      text:
        '不同于一些常见到的表皮发白发灰的红薯，叮咚买菜基地种出来的烟薯，通体透着均匀的红色，且口感软糯少筋，香甜易流蜜，不干也不噎人，尤其适合烤食，在平台上获得了非常高的评价。',
    }, 
    {
      type: 1,
      title: '',
      src: [image3],
    },
    {
      type: NewsContentType.Text,
      text:
        '而令人无法想象的是，这一片种出好吃、流蜜的烟薯的沙地，之前却是一座几近被忽视的荒山头，地里多是乱石，只有少量的种植面积，并不成规模。',
    }, 
    {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      text:
        '基地其实也一直在寻找合适的种植区域。按照段伦江的经验，种植红薯的土壤，沙与土的比例在3:7左右为最佳，当专业的种植团队到来之后，发现这里正有着颇为理想的沙地土质，且还有着较强的昼夜温差，可以更好地积累糖分，非常适合红薯生长，只是由于整地的成本对村民来说相对过高，这片地就一直没有被很好地利用起来。',
    }, 
    {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      text:
        '于是在相关部门的支持下，从用挖掘机翻石头、修路开始，他们将山坡的土壤翻平、整地、起垄，让这个曾经的荒山头摇身一变成为如今数千亩的种植基地。目前，首批1500亩的种植面积，平均每天为叮咚买菜供应约40万斤的高品质红薯。',
    }, 
    {
      type: 1,
      title: '',
      src: [image4],
    },
    {
      type: NewsContentType.Text,
      text:
        '段伦江明白，对于个体和小农户而言，种植面积是有天花板的，付出的精力和成本也有限，因此真正好的产地和农产品的持续发展，离不开规模化的投入和稳定的市场渠道支撑。就像手中的烟薯，有了叮咚买菜等标准化的销售渠道，种植者再也不用担心没有好销路、好收益这一问题。',
    }, 
    {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      text:
        '而更让他和团队有成就感的，还是对当地农民的帮扶与影响。',
    }, 
    {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      text:
        '和很多农村一样，基地周围的村落留守的老年人比较多，大部分年龄都在50-70岁，他们不再有体力离开家去做工，还是要靠打了一辈子交道的土地来生活。如今在基地的带动下，村里几十户村民都加入了基地的种植和采收，今年一个种植周期下来，平均年收入能增加近两万元。',
    }, 
    {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      text:
        '叮咚买菜农场经理缪体云也认为，随着市场结构和消费需求在不断改变，即使是最基础的农产品，供应链路中也存在很大的优化空间，农民作为农业重要的一员，其实也在主动或被动地接受着更多的改变。',
    }, 
    {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      text:
        '据悉，叮咚买菜的绿水青山项目要做的，就是关注优质产地、优质农产品和有着相同理念的种植者，通过线上模式打通农产品供需两侧，为消费者提供好的商品，同时提高周边农户收入，带动农产品产业升级。目前绿水青山项目进入第二个年头，已经引入大竹县香椿、德阳翠冠梨、宁夏菜心、新疆天山雪蟹、济南烟薯等一系列优质农货到线上。',
    }, 
    {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      text:
        '“在提供好销路的同时，还要通过改变传统零散种植的观念和思路，来帮助农民获得更稳定的收入，这是更重要、更长远的。”缪体云说。',
    }, 
  ],
};
